import { LOGOS } from '../demo/copy'

/**
 * Copy der Version „Aivy Play“. Zahlen, Zitate und Fallstudien wie im
 * Demo-Deck 2026 (v12), Report und Profil sind Beispieldaten.
 */

export const LINKS = {
  demo: 'https://www.aivy.app/gespraech-vereinbaren',
  start: '/funnel'
}

export const QUOTE_LOGOS = {
  omr: LOGOS.omr,
  callways: LOGOS.callways,
  persona: LOGOS.personaService,
  lufthansa: LOGOS.lufthansa
}

export const MARQUEE = [
  LOGOS.lufthansa,
  LOGOS.beiersdorf,
  LOGOS.omr,
  LOGOS.frankfurtSchool,
  LOGOS.callways,
  LOGOS.mci,
  LOGOS.personaService
]

const de = {
  ui: {
    chapters: 'Kapitel',
    sample: 'Beispieldaten',
    cue: 'Scroll los',
    locale: 'de-DE',
    demo: 'Demo buchen',
    start: 'Kostenlos starten',
    dock: 'Lust, es an deiner Stelle zu sehen?'
  },
  chapters: {
    hero: 'Aivy',
    lebenslauf: 'Mehr als der Lebenslauf',
    schritte: 'Drei Schritte',
    spiele: 'Spiele statt Fragebogen',
    talentwerte: 'Talentwerte',
    belege: 'Belegt',
    stimmen: 'Stimmen',
    start: 'Loslegen'
  },
  hero: {
    eyebrow: 'Software für fundierte Vorauswahl',
    title: ['Sieh, was in', 'Menschen steckt.'],
    sub: 'Aivy macht Stärken sichtbar, bevor das erste Gespräch beginnt. Spielbasiert, wissenschaftlich fundiert und fair für alle.',
    trust: ['200+ Unternehmen', 'DIN 33430 konform', 'Server in Frankfurt'],
    tagline: 'Know before you decide.'
  },
  lebenslauf: {
    before: ['Ein Lebenslauf zeigt,', 'wo jemand war.'],
    after: ['Aivy zeigt,', 'was jemand kann.'],
    cv: 'Lebenslauf',
    talents: [
      'Problemlösen',
      'Sorgfalt',
      'Belastbarkeit',
      'Motivation',
      'Passung',
      'Merkfähigkeit'
    ],
    stat: '5×',
    statLabel: 'höhere Vorhersagekraft als klassische Unterlagen',
    statSource: 'Fallstudie Frankfurt School'
  },
  schritte: {
    eyebrow: 'So funktioniert Aivy',
    title: 'Drei Schritte. Ein klares Bild.',
    steps: [
      {
        title: 'Anforderungen definieren',
        text: 'Fachbereich, HR und Teamleitung schätzen unabhängig ein, was die Stelle wirklich braucht. 5 bis 10 Minuten pro Person.'
      },
      {
        title: 'Stärken sichtbar machen',
        text: 'Bewerbende spielen kurze Verfahren am Smartphone oder PC. Ohne Vorbereitung und ohne Lebenslauf.'
      },
      {
        title: 'Passung sehen',
        text: 'Das Profil wird gegen die Anforderungen gerechnet. Du siehst einen Gesamtscore und die Passung je Dimension.'
      }
    ],
    experts: ['Fachbereich', 'HR', 'Teamleitung'],
    target: 'Zielbereich',
    minutes: '5 bis 10 Min.',
    score: 'Gesamtscore',
    fit: 'Hohe Passung'
  },
  spiele: {
    title: ['Kein Fragebogen.', 'Ein Spiel.'],
    sub: 'Echte Aufnahmen aus der Aivy-App. Jedes Spiel misst etwas anderes und dauert nur wenige Minuten.',
    games: [
      { name: 'Codeknacker', dim: 'Merkfähigkeit', time: '3 Min.' },
      { name: 'Hochstapler', dim: 'Problemlösefähigkeit', time: '3 Min.' },
      { name: 'Gefühlschaos', dim: 'Emotionswahrnehmung', time: '2 Min.' },
      { name: 'Selbsterkenntnis', dim: 'Persönlichkeit', time: '2 Min.' },
      {
        name: 'Tätigkeitsvielfalt',
        dim: 'Berufliche Interessen',
        time: '2 Min.'
      }
    ],
    stats: [
      { value: '9/10', label: 'Bewerbenden bevorzugen Aivy' },
      { value: '94 %', label: 'Abschlussrate bei EnBW' },
      { value: '12', label: 'validierte Verfahren' }
    ]
  },
  talentwerte: {
    eyebrow: 'Ergebnisreport',
    title: 'Talentwerte statt Bauchgefühl.',
    sub: 'Jede Dimension gegen den Zielbereich der Stelle. Gerechnet gegen das Anforderungsprofil, nicht gegen das Bewerberfeld.',
    dims: [
      'Problemlösefähigkeit',
      'Mathematisches Verständnis',
      'Sprachliche Problemlösefähigkeit',
      'Merkfähigkeit'
    ],
    target: 'Zielbereich',
    tolerance: 'Toleranz',
    person: 'Wert der Person',
    must: 'Muss',
    score: 'Gesamtscore',
    fit: 'Hohe Passung',
    hint: 'Frag im Interview nach, wie die Person mit vielen Details gleichzeitig umgeht.',
    hintTitle: 'Empfehlung für das Interview'
  },
  belege: {
    eyebrow: 'Aus dem Einsatz',
    title: 'Belegt in echten Prozessen.',
    tiles: [
      {
        value: '96 %',
        label: 'Trefferquote vor dem Interview',
        source: 'Lufthansa Group'
      },
      {
        value: '70 %',
        label: 'weniger Aufwand in der Vorauswahl',
        source: 'Callways'
      },
      { value: '55 %', label: 'kürzere Time-to-Hire', source: 'MCI' },
      {
        value: '5×',
        label: 'höhere Vorhersagekraft',
        source: 'Frankfurt School'
      },
      {
        value: '1.000.000+',
        label: 'Testungen durchgeführt',
        source: 'Aivy'
      },
      { value: '200+', label: 'Unternehmen im Einsatz', source: 'Aivy' },
      {
        value: '20.000+',
        label: 'absolvierte Self-Assessments',
        source: 'Beiersdorf'
      },
      {
        value: '9/10',
        label: 'Bewerbenden bevorzugen Aivy',
        source: 'Nutzertest, N = 450'
      }
    ],
    badges: ['DIN 33430 konform', 'EU AI Act sicher', 'Server in Frankfurt'],
    science: 'Entstanden aus Forschung an der Freien Universität Berlin.'
  },
  stimmen: {
    eyebrow: 'Was Teams sagen',
    quotes: [
      {
        id: 'omr',
        text: 'Wir hatten Fälle, die wir sonst abgesagt hätten, Aivy zeigte Potenzial. Wir haben eingeladen und sogar eingestellt.',
        author: 'Kaya Kruse',
        role: 'People Lead, OMR'
      },
      {
        id: 'callways',
        text: 'Wir schicken allen sofort den Aivy-Link. Es ist ein Geschenk für beide Seiten.',
        author: 'Achim Reinhardt',
        role: 'Co-CEO, Callways'
      },
      {
        id: 'persona',
        text: 'Wenn ich rein vom Lebenslauf ausgehe, hätte ich sie wahrscheinlich nicht zum Vorstellungsgespräch eingeladen.',
        author: 'Christin Seel',
        role: 'Regionalleiterin, persona service'
      }
    ],
    trust: '200+ HR-Teams jeder Größe und Branche vertrauen Aivy'
  },
  start: {
    eyebrow: 'Dein nächster Schritt',
    title: ['Sieh es an deiner', 'eigenen Stelle.'],
    sub: 'Wir zeigen dir Aivy live mit deinen Anforderungen. Oder du legst direkt selbst los und testest Aivy kostenlos.',
    steps: ['Kennenlernen', 'Live-Demo', 'Business Case', 'Start als #HeRo'],
    poke: 'Tipp: Stups die Formen an.',
    candidate: 'Aus Sicht der Bewerbenden',
    again: 'Nochmal von vorn'
  }
}

const en = {
  ui: {
    chapters: 'Chapters',
    sample: 'Sample data',
    cue: 'Scroll to start',
    locale: 'en-US',
    demo: 'Book a demo',
    start: 'Start for free',
    dock: 'Want to see it for your own role?'
  },
  chapters: {
    hero: 'Aivy',
    lebenslauf: 'Beyond the CV',
    schritte: 'Three steps',
    spiele: 'Games, not forms',
    talentwerte: 'Talent scores',
    belege: 'Proof',
    stimmen: 'Voices',
    start: 'Get started'
  },
  hero: {
    eyebrow: 'Software for evidence-based pre-selection',
    title: ['See what people', 'are capable of.'],
    sub: 'Aivy makes strengths visible before the first interview starts. Game-based, scientifically grounded and fair for everyone.',
    trust: ['200+ companies', 'DIN 33430 compliant', 'Servers in Frankfurt'],
    tagline: 'Know before you decide.'
  },
  lebenslauf: {
    before: ['A CV shows', 'where someone has been.'],
    after: ['Aivy shows', 'what someone can do.'],
    cv: 'CV',
    talents: [
      'Problem solving',
      'Diligence',
      'Resilience',
      'Motivation',
      'Fit',
      'Memory'
    ],
    stat: '5×',
    statLabel: 'higher predictive power than traditional documents',
    statSource: 'Frankfurt School case study'
  },
  schritte: {
    eyebrow: 'How Aivy works',
    title: 'Three steps. One clear picture.',
    steps: [
      {
        title: 'Define requirements',
        text: 'The department, HR and team lead independently rate what the role really needs. 5 to 10 minutes per person.'
      },
      {
        title: 'Make strengths visible',
        text: 'Candidates play short assessments on their phone or PC. No preparation and no CV.'
      },
      {
        title: 'See the fit',
        text: 'The profile is matched against the requirements. You get an overall score and the fit per dimension.'
      }
    ],
    experts: ['Department', 'HR', 'Team lead'],
    target: 'Target range',
    minutes: '5 to 10 min',
    score: 'Overall score',
    fit: 'High fit'
  },
  spiele: {
    title: ['No questionnaire.', 'A game.'],
    sub: 'Real recordings from the Aivy app. Each game measures something different and takes only a few minutes.',
    games: [
      { name: 'Codeknacker', dim: 'Memory', time: '3 min' },
      { name: 'Hochstapler', dim: 'Problem solving', time: '3 min' },
      { name: 'Gefühlschaos', dim: 'Emotion perception', time: '2 min' },
      { name: 'Selbsterkenntnis', dim: 'Personality', time: '2 min' },
      { name: 'Tätigkeitsvielfalt', dim: 'Career interests', time: '2 min' }
    ],
    stats: [
      { value: '9/10', label: 'candidates prefer Aivy' },
      { value: '94 %', label: 'completion rate at EnBW' },
      { value: '12', label: 'validated assessments' }
    ]
  },
  talentwerte: {
    eyebrow: 'Results report',
    title: 'Talent scores, not gut feeling.',
    sub: 'Every dimension against the target range of the role. Matched against the requirements profile, not against the other applicants.',
    dims: [
      'Problem solving',
      'Numerical reasoning',
      'Verbal problem solving',
      'Memory'
    ],
    target: 'Target range',
    tolerance: 'Tolerance',
    person: 'Candidate score',
    must: 'Must',
    score: 'Overall score',
    fit: 'High fit',
    hint: 'Ask in the interview how the person handles many details at once.',
    hintTitle: 'Interview recommendation'
  },
  belege: {
    eyebrow: 'From real use',
    title: 'Proven in real processes.',
    tiles: [
      {
        value: '96 %',
        label: 'hit rate before the interview',
        source: 'Lufthansa Group'
      },
      {
        value: '70 %',
        label: 'less effort in pre-selection',
        source: 'Callways'
      },
      { value: '55 %', label: 'shorter time to hire', source: 'MCI' },
      {
        value: '5×',
        label: 'higher predictive power',
        source: 'Frankfurt School'
      },
      { value: '1,000,000+', label: 'assessments completed', source: 'Aivy' },
      { value: '200+', label: 'companies using Aivy', source: 'Aivy' },
      {
        value: '20,000+',
        label: 'self-assessments completed',
        source: 'Beiersdorf'
      },
      {
        value: '9/10',
        label: 'candidates prefer Aivy',
        source: 'User test, N = 450'
      }
    ],
    badges: ['DIN 33430 compliant', 'EU AI Act ready', 'Servers in Frankfurt'],
    science: 'Grown out of research at Freie Universität Berlin.'
  },
  stimmen: {
    eyebrow: 'What teams say',
    quotes: [
      {
        id: 'omr',
        text: 'We had cases we would otherwise have rejected, Aivy showed potential. We invited them and even hired.',
        author: 'Kaya Kruse',
        role: 'People Lead, OMR'
      },
      {
        id: 'callways',
        text: 'We send everyone the Aivy link right away. It is a gift for both sides.',
        author: 'Achim Reinhardt',
        role: 'Co-CEO, Callways'
      },
      {
        id: 'persona',
        text: 'Going by the CV alone, I probably would not have invited her to an interview.',
        author: 'Christin Seel',
        role: 'Regional Manager, persona service'
      }
    ],
    trust: '200+ HR teams of every size and industry trust Aivy'
  },
  start: {
    eyebrow: 'Your next step',
    title: ['See it for', 'your own role.'],
    sub: 'We show you Aivy live with your requirements. Or you get started yourself and try Aivy for free.',
    steps: ['Intro call', 'Live demo', 'Business case', 'Start as #HeRo'],
    poke: 'Tip: give the shapes a nudge.',
    candidate: 'The candidate view',
    again: 'Start over'
  }
}

export const PLAY_COPY = { de, en }
